import React from 'react'
import './About.css'
import abhi from './images/abhi0.3.jpg'
import { Link } from 'react-scroll'

const About = () => {
  return (
    <section name='About' className='about' aria-label="About section">
      <div className="about__bg-glow" aria-hidden="true" />

      <div className="about__container container">

        {/* Left — CEO photo */}
        <div className="about__col-photo reveal reveal-left">
          <div className="about__photo-wrap">
            <img src={abhi} alt="Abhishek Jadhav — Founder &amp; CEO" className="about__photo" />
            <div className="about__photo-ring" aria-hidden="true" />
          </div>
          <p className="about__name">ABHISHEK JADHAV</p>
          <p className="about__title">Founder &amp; CEO</p>
        </div>

        {/* Right — text */}
        <div className="about__col-text reveal reveal-right">
          <p className="about__eyebrow">Who We Are</p>
          <h2 className="about__heading">About <span className="about__heading-accent">GetNet</span></h2>
          <span className="section-line" />

          <p className="about__body">
            Abhishek Jadhav, proud owner and CEO of GetNet Internet Service Provider.
            With a decade of experience in the industry, we have been providing
            lightning-fast local broadband solutions to empower individuals and
            businesses alike. Join us on the digital expressway and experience
            internet like never before!
          </p>

          <p className="about__body about__body--italic">
            Join us on the fast lane to seamless online experiences. Let's connect your world!
          </p>

          <div className="about__stats">
            <div className="about__stat">
              <span className="about__stat-num">10+</span>
              <span className="about__stat-label">Years Experience</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-num">500+</span>
              <span className="about__stat-label">Happy Customers</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-num">99.9%</span>
              <span className="about__stat-label">Uptime</span>
            </div>
          </div>

          <Link to="OurTeam" smooth duration={500}>
            <button className="btn-primary about__btn">
              Meet Our Team
            </button>
          </Link>
        </div>

      </div>
    </section>
  )
}

export default About
